import React from "react";
import { ArrowLeft, ArrowRight, Building2 } from "lucide-react";
import { AZ_BANKS } from "../data/banks";
import { usePulpayConfig } from "../hooks/usePulpayConfig";

export default function BankSelection({ go, user, onPickBank }) {
  const fullName = user?.firstName || "";
  const config = usePulpayConfig();
  const logos = config.bank_logos || {};

  return (
    <section className="screen bs-screen" data-testid="bank-selection-screen">
      <button
        className="bs-back"
        onClick={() => go("home")}
        aria-label="Geri"
        data-testid="bs-back-btn"
      >
        <ArrowLeft size={20} strokeWidth={2.6} />
      </button>

      <div className="bs-content">
        <div className="bs-head">
          <div className="bs-head-badge">
            <Building2 size={14} strokeWidth={2.8} />
            <span>Bank seçimi</span>
          </div>
          <h2 className="bs-title">
            {fullName ? (
              <>
                Salam, <span className="bs-name">{fullName}</span>
              </>
            ) : (
              "Salam!"
            )}
          </h2>
          <p className="bs-sub">Krediti hansı karta göndərək?</p>
        </div>

        <div className="bs-grid" data-testid="bs-banks-grid">
          {AZ_BANKS.map((b) => {
            const logoUrl = logos[b.key];
            return (
              <button
                key={b.key}
                type="button"
                className="bs-bank"
                onClick={() => onPickBank(b.key)}
                data-testid={`bs-bank-${b.key}`}
                style={{
                  "--bank-primary": b.primary,
                  "--bank-secondary": b.secondary,
                }}
              >
                <div className="bs-bank-logo">
                  {logoUrl ? (
                    <img src={logoUrl} alt={b.name} onError={(e) => { e.currentTarget.style.display = "none"; }} />
                  ) : (
                    <span>{b.short}</span>
                  )}
                </div>
                <div className="bs-bank-txt">
                  <b>{b.name}</b>
                  <span>Karta köçür</span>
                </div>
                <span className="bs-bank-arrow">
                  <ArrowRight size={16} strokeWidth={2.8} />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
